import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Portal } from 'react-portal';

import sendDataToMobileApp, {
  SR_MOBILE_APP_ACTION_TYPE_REQUEST_PUSH_NOTIFICATION_PERMISSION,
} from 'client/helpers/sendDataToMobileApp';

import { hasRolePartner, hasRoleLandlord } from 'common/userRoles';

import SrBox from 'client/components/SrBox';
import ButtonDeprecated, {
  BUTTON_THEME_WHITE,
  BUTTON_THEME_BLUE,
} from 'client/components/ButtonDeprecated';

import branch from 'client/core/branch';

@branch({
  currentUser: ['currentUser'],
})
class SrEnablePushNotificationsModal extends Component {
  static propTypes = {
    onClose: PropTypes.func,
    isTourSection: PropTypes.bool,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func.isRequired,
  };

  _onEnablePushNoficationsClick = () => {
    const { onClose, dispatch } = this.props;
    sendDataToMobileApp({
      actionType: SR_MOBILE_APP_ACTION_TYPE_REQUEST_PUSH_NOTIFICATION_PERMISSION,
    });
    setTimeout(() => {
      dispatch(({ state }) => {
        state.set(['mobileApp', 'askPushNotifications'], false);
      });
      if (onClose) {
        onClose();
      }
    }, 500);
  };

  render() {
    const { onClose, isTourSection, currentUser } = this.props;
    const isPartner = hasRolePartner(currentUser.roles) || hasRoleLandlord(currentUser.roles);

    const title = isPartner
      ? 'important notifications'
      : isTourSection
      ? 'tour notifications'
      : 'be the first';

    const subtitle = isPartner
      ? 'Get notified when renters are interested & apply to your listings'
      : isTourSection
      ? 'Get notified if your tour changes at all'
      : 'Get notified when new homes come on the market';

    return (
      <Portal>
        <div
          className={classnames('modal success confirm push webview', {
            partner: isPartner,
          })}
        >
          <div className="contentContainer">
            <div className="heroIcon" />
            <div className="textContainer">
              <span className="category">{title}</span>
              <span className="headline">{subtitle}</span>
            </div>

            <SrBox className="actionsContainer" margin="0 auto">
              <ButtonDeprecated theme={BUTTON_THEME_WHITE} onClick={onClose}>
                not now
              </ButtonDeprecated>
              <SrBox width="15px" />
              <ButtonDeprecated
                theme={BUTTON_THEME_BLUE}
                onClick={this._onEnablePushNoficationsClick}
              >
                ok
              </ButtonDeprecated>
            </SrBox>
          </div>
        </div>
      </Portal>
    );
  }
}

SrEnablePushNotificationsModal.displayName = 'SrEnablePushNotificationsModal';

export default SrEnablePushNotificationsModal;
